import { render, staticRenderFns } from "./ClienteApp.vue?vue&type=template&id=445e95c3&scoped=true&"
import script from "./ClienteApp.vue?vue&type=script&lang=js&"
export * from "./ClienteApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445e95c3",
  null
  
)

export default component.exports